// 个人中心栏目页
import request from '@/utils/request'

// 账号信息管理-修改密码
export function edit_password(data) {
  return request({
    url: '/index/person/edit_password',
    method: 'post',
    data: data
  })
}

// 账号信息管理-账号绑定
export function bindtianpo (data) {
  return request({
    url: '/index/login/bindtianpo',
    method: 'post',
    data: data
  })
}

// 账号信息管理-账号解绑
export function deltianpo (data) {
  return request({
    url: '/index/login/deltianpo ',
    method: 'post',
    data: data
  })
}

// 选择会员--采购商/供应商
export function company_save(data) {
  return request({
    url: '/index/member/company_save',
    method: 'post',
    data: data
  })
}

// 选择会员--设计师/设计公司
export function designer_save(data) {
  return request({
    url: '/index/member/designer_save',
    method: 'post',
    data: data
  })
}


// 企业信息管理--获取企业信息
export function get_company_info(data) {
  return request({
    url: '/index/person/get_company_info',
    method: 'post',
    data: data
  })
}


// 设计师信息管理--获取设计师信息
export function get_designer_info(data) {
  return request({
    url: '/index/person/get_designer_info',
    method: 'post',
    data: data
  })
}

// 判断设计师是否可以发布作品
export function designer_work_search(data) {
  return request({
    url: '/index/person/designer_work_search',
    method: 'post',
    data: data
  })
}

// 企业信息管理--获取主营行业
export function company_cate(data) {
  return request({
    url: '/index/member/company_cate',
    method: 'post',
    data: data
  })
}

// 会员服务--购买会员
export function ordersave(data) {
  return request({
    url: '/index/member/ordersave',
    method: 'post',
    data: data
  })
}

// 会员服务--购买会员--是否支付
export function pay_status1(data) {
  return request({
    url: '/index/member/pay_status',
    method: 'post',
    data: data
  })
}

// 会员服务--购买会员--订单是否存在
export function member_order(data) {
  return request({
    url: '/index/member/member_order',
    method: 'post',
    data: data
  })
}


// 会员服务--购买会员--判断是否可以购买天珀产品
export function get_company_cate(data) {
  return request({
    url: '/index/member/get_company_cate',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/userCenter/personal.js